"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipContentAuthorProperty = exports.tipContentAuthorPropertyDefinition = void 0;
exports.tipContentAuthorPropertyDefinition = {
    view: { label: 'Author' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'tip-content-author',
};
const isTipContentAuthorProperty = (prop) => {
    return prop.name === exports.tipContentAuthorPropertyDefinition.name;
};
exports.isTipContentAuthorProperty = isTipContentAuthorProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLWNvbnRlbnQtYXV0aG9yLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGlwLWNvbnRlbnQtYXV0aG9yLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsb0JBQW9CO0NBQ0ssQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9